import { render, staticRenderFns } from "./Pdf-8.vue?vue&type=template&id=36e55f36"
import script from "./Pdf-8.vue?vue&type=script&lang=js"
export * from "./Pdf-8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports